import { create } from "zustand";
import { persist } from "zustand/middleware";

// Zustand 스토어 생성
const useAuthStore = create(
  // persist 미들웨어를 사용하여 localStorage에 상태를 저장합니다.
  persist(
    (set) => ({
      token: null,
      user: null,
      // 로그인 시 호출될 함수
      login: (authResult) => {
        set({ token: authResult.token, user: authResult.user });
      },
      // 로그아웃 시 호출될 함수
      logout: () => {
        set({ token: null, user: null });
      },
    }),
    {
      name: "auth-storage", // localStorage에 저장될 때 사용될 키 이름
    }
  )
);

export default useAuthStore;
